module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect-0d457873a2fc4f09d7c8cfb874b841d7.png";